import { h, Host } from "@stencil/core";
const baseClass = "ux-tab-switcher";
export class TabSwitcher {
    constructor() {
        this.tabId = "";
        this.tabColor = "";
        this.noBorder = false;
        this.type = "button";
        this.active = false;
    }
    element;
    tabContainer = null;
    radioBtn = null;
    componentWillLoad() {
        if (this.tabId === "") {
            return;
        }
        // @ts-expect-error Check for typing
        this.tabContainer = document
            .querySelector(`ux-tab[tab-id=${this.tabId}]`)
            .closest("ux-tab-container");
        this.active = this.tabContainer.activeTabId === this.tabId;
        this.tabContainer.addEventListener("uxActiveTabSet", (e) => {
            this.active = e.detail === this.tabId;
        });
        this.radioBtn = this.element.querySelector("ux-radio-button");
    }
    componentWillUpdate() {
        if (this.radioBtn !== null && this.radioBtn !== undefined) {
            this.radioBtn.checked = this.active;
        }
    }
    render() {
        return (h(Host, { key: 'bec46d3121b16123a8d0f44e27b6e446707eb24e', class: {
                [`${baseClass}`]: true,
                [`${baseClass}--link ux-text-link ux-text-link--green`]: this.type === "link",
                [`${baseClass}--${this.tabColor}`]: this.tabColor !== "",
                [`${baseClass}--no-border`]: this.noBorder,
                ["ux-button"]: this.type === "button",
                ["ux-button--toggle"]: this.type === "button" && !this.active,
                ["ux-button--toggle-active"]: this.type === "button" && this.active
            }, onClick: () => {
                if (this.tabContainer === null || this.tabId === "") {
                    return;
                }
                this.tabContainer.setActiveTab(this.tabId);
            } }, h("slot", { key: 'bf292c96eba94bc01f86f7f638e9efd659ce9d2c' })));
    }
    static get is() { return "ux-tab-switcher"; }
    static get originalStyleUrls() {
        return {
            "$": ["tab-switcher.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab-switcher.css"]
        };
    }
    static get properties() {
        return {
            "tabId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "identifier of the targeted tab"
                },
                "attribute": "tab-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "tabColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "set custom tab color;\ncurrently available colors: grey"
                },
                "attribute": "tab-color",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "noBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes border from tab button if set to true"
                },
                "attribute": "no-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"button\" | \"link\"",
                    "resolved": "\"button\" | \"link\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "define appearance of ux-tab-switcher"
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"button\""
            }
        };
    }
    static get states() {
        return {
            "active": {}
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=tab-switcher.js.map
